import request from '@/utils/request'


// 查询国家信息列表
export function listCountry(query) {
  return request({
    url: '/video/video-country/list',
    method: 'get',
    params: query
  })
}

// 查询国家信息分页
export function pageCountry(query) {
  return request({
    url: '/video/video-country/page',
    method: 'get',
    params: query
  })
}

// 查询国家信息详细
export function getCountry(data) {
  return request({
    url: '/video/video-country/detail',
    method: 'get',
    params: data
  })
}

// 新增国家信息
export function addCountry(data) {
  return request({
    url: '/video/video-country/add',
    method: 'post',
    data: data
  })
}

// 修改国家信息
export function updateCountry(data) {
  return request({
    url: '/video/video-country/edit',
    method: 'post',
    data: data
  })
}

// 删除国家信息
export function delCountry(data) {
  return request({
    url: '/video/video-country/delete',
    method: 'post',
    data: data
  })
}
